import { BIM_ERROR, BIM_LOGIN, BIM_VIEW, } from "../../typesAction";

const INITIAL_STATE = {
  auth: false,
  message: "... ee",
  inProgress: true,
  urn: false,
  error: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case  BIM_LOGIN:
      return {
        ...state,
        auth: action.payload,
        message: "... completed"
      };

    case BIM_VIEW:
      return {
        ...state,
        urn: action.payload.urn,
        message: action.payload.urn,
      };

    case BIM_ERROR:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        message: "... error"
      };
    default:
      return state;
  }
}
